import pulse from '@finn-no/pulse-sdk';

const getCategory = adModel => `realestate > ${adModel}`;

/* 
    PULSE
    Action events, like Click, Open, Edit, etc. 
*/

// RE_ev29 - Click on unique customer content new building ads

export function trackEventViewCustomerContent(adId, trackingContext) {
  const { projectName, adModel } = trackingContext;

  pulse.trackEvent({
    type: 'Click',
    intent: 'Open',
    name: 'Customer content clicked',
    object: {
      id: `${adId}`,
      type: 'UIElement',
      elementType: 'Link',
      items: [
        {
          type: 'ClassifiedAd',
          id: `${adId}`,
          contentId: `${adId}`,
          name: projectName,
          category: getCategory(adModel),
          hasExtendedProfile: true,
        },
      ],
    },
    target: {
      id: `${adId}`,
      type: 'ExternalContent',
      name: 'Go to webpage',
      referralCommission: false
    },
  });
}
